import script from "./ChatMessageActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageActions.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageActions.vue?vue&type=style&index=0&id=b903ddd4&scoped=true&lang=scss"
import "./ChatMessageActions.vue?vue&type=style&index=1&id=b903ddd4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b903ddd4"]])

export default __exports__